import { useState } from 'react'

export function useSearchQuery(initialState: string) {
  const [searchQuery, setSearchQuery] = useState(initialState)

  return { searchQuery, setSearchQuery }
}
